function initNotificationsBulkActions() {
  const checkAll = document.getElementById("notifications-check-all");
  const toolbar = document.getElementById("notifications-bulk-toolbar");
  const form = document.getElementById("notifications-bulk-form");
  const countEl = document.getElementById("selected-notifications-count");
  const scopeEl = document.getElementById("notifications-selection-scope");
  const clearBtn = document.getElementById("clear-notifications-selection");
  const selectAllMatchingInput = document.getElementById("select-all-matching-notifications");
  const selectAllPagesBanner = document.getElementById("notifications-select-all-pages-banner");
  const selectAllPagesMessage = document.getElementById("notifications-select-all-pages-message");
  const selectAllMatchingBtn = document.getElementById("select-all-matching-notifications-btn");
  const clearAllMatchingBtn = document.getElementById("clear-all-matching-notifications-btn");
  const actionButtons = Array.from(document.querySelectorAll(".notifications-bulk-action"));
  const rowChecks = Array.from(document.querySelectorAll(".notification-row-check"));

  if (!checkAll || !toolbar || !form || !countEl) return;
  if (toolbar.dataset.notificationsBulkReady === "true") return;
  toolbar.dataset.notificationsBulkReady = "true";

  const totalCount = selectAllPagesBanner ? Number(selectAllPagesBanner.dataset.totalCount || 0) : 0;
  const pageCount = selectAllPagesBanner ? Number(selectAllPagesBanner.dataset.pageCount || 0) : rowChecks.length;

  function isSelectingAllMatching() {
    return selectAllMatchingInput && selectAllMatchingInput.value === "1";
  }

  function setSelectingAllMatching(active) {
    if (selectAllMatchingInput) {
      selectAllMatchingInput.value = active ? "1" : "0";
    }
  }

  function formatNotifications(count) {
    return count === 1 ? "1 notificação" : `${count} notificações`;
  }

  function selectedPageCount() {
    return rowChecks.filter((checkbox) => checkbox.checked).length;
  }

  function updateSelectAllPagesBanner(selected) {
    if (!selectAllPagesBanner || !selectAllPagesMessage) return;

    const hasMoreItems = totalCount > pageCount;
    const wholePageSelected = selected === pageCount && pageCount > 0;

    if (!hasMoreItems || !wholePageSelected) {
      selectAllPagesBanner.classList.add("d-none");
      return;
    }

    selectAllPagesBanner.classList.remove("d-none");

    if (isSelectingAllMatching()) {
      selectAllPagesMessage.textContent = `Todas as ${formatNotifications(totalCount)} foram selecionadas.`;
      selectAllMatchingBtn?.classList.add("d-none");
      clearAllMatchingBtn?.classList.remove("d-none");
    } else {
      selectAllPagesMessage.textContent = `Todas as ${formatNotifications(pageCount)} desta página foram selecionadas.`;

      if (selectAllMatchingBtn) {
        selectAllMatchingBtn.textContent = `Selecionar todas as ${formatNotifications(totalCount)}`;
        selectAllMatchingBtn.classList.remove("d-none");
      }

      clearAllMatchingBtn?.classList.add("d-none");
    }
  }

  function updateToolbar() {
    const selected = selectedPageCount();
    const displayCount = isSelectingAllMatching() ? totalCount : selected;

    countEl.textContent = displayCount;
    if (scopeEl) {
      scopeEl.textContent = isSelectingAllMatching() ? "incluindo outras páginas" : "nesta página";
    }

    toolbar.classList.toggle("d-none", displayCount < 1);
    actionButtons.forEach((button) => {
      button.disabled = displayCount < 1;
    });

    updateSelectAllPagesBanner(selected);

    if (selected === rowChecks.length && rowChecks.length > 0) {
      checkAll.checked = true;
      checkAll.indeterminate = false;
    } else if (selected > 0) {
      checkAll.checked = false;
      checkAll.indeterminate = true;
    } else {
      checkAll.checked = false;
      checkAll.indeterminate = false;
    }
  }

  checkAll.addEventListener("change", () => {
    setSelectingAllMatching(false);
    rowChecks.forEach((checkbox) => {
      checkbox.checked = checkAll.checked;
    });
    updateToolbar();
  });

  rowChecks.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      setSelectingAllMatching(false);
      updateToolbar();
    });
  });

  clearBtn?.addEventListener("click", () => {
    setSelectingAllMatching(false);
    rowChecks.forEach((checkbox) => {
      checkbox.checked = false;
    });
    updateToolbar();
  });

  selectAllMatchingBtn?.addEventListener("click", () => {
    setSelectingAllMatching(true);
    rowChecks.forEach((checkbox) => {
      checkbox.checked = true;
    });
    updateToolbar();
  });

  clearAllMatchingBtn?.addEventListener("click", () => {
    setSelectingAllMatching(false);
    updateToolbar();
  });

  form.addEventListener("submit", (event) => {
    if (isSelectingAllMatching() || selectedPageCount() > 0) return;

    event.preventDefault();
  });

  if (rowChecks.length === 0) {
    checkAll.checked = false;
    checkAll.indeterminate = false;
    checkAll.disabled = true;
  }

  updateToolbar();
}

document.addEventListener("turbo:load", initNotificationsBulkActions);
document.addEventListener("DOMContentLoaded", initNotificationsBulkActions);
